import Box from '@mui/material/Box/Box';
import Stack from '@mui/material/Stack/Stack';
import { useTranslation } from 'react-i18next';

import { PlusIconDark, PlusSquareIcon } from '../../../../../../assets/icons';
import { getIsSupercellTemplate } from '../../../../../../utils/get-is-supercell-template';

import './styles.scss';

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

interface NewCardButtonProps {
  onClick: () => void;
}
export function NewCardButton({ onClick }: NewCardButtonProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  return (
    <Stack
      onClick={onClick}
      className="new-card-button"
      direction="row"
      alignItems={'center'}
      spacing={1}
    >
      {IS_SUPERCELL_TEMPLATE ? <PlusIconDark /> : <PlusSquareIcon />}
      <Box className="text">{t('newCard')}</Box>
    </Stack>
  );
}
